import { color } from 'd3';
import * as Yup from 'yup';

export const SelectHmdForm = {
  hmd: '',
};

export const hmdColors = [
  { name: 'Cyan', hex: '00FFFF', rgb: '0, 255, 255' },
  { name: 'Teal', hex: '008080', rgb: '0, 128, 128' },
  { name: 'Deep Pink', hex: 'FF1493', rgb: '255, 20, 147' },
  { name: 'Blue', hex: '0000FF', rgb: '0, 0, 255' },
  { name: 'Orange', hex: 'FFA500', rgb: '255, 165, 0' },
  { name: 'Purple', hex: '800080', rgb: '128, 0, 128' },
  { name: 'Olive', hex: '808000', rgb: '128, 128, 0' },
  { name: 'Pink', hex: 'FFC0CB', rgb: '255, 192, 203' },
  { name: 'Yellow-Green', hex: '7FFF00', rgb: '127, 255, 0' },
  { name: 'Blue-Green', hex: '00FF7F', rgb: '0, 255, 127' },
  { name: 'Blue-Purple', hex: '4B0082', rgb: '75, 0, 130' },
  { name: 'Maroon', hex: '800000', rgb: '128, 0, 0' },
];

export const AddHmdForm = {
  name: '',
  deviceId: '',
  color: ''
};

export const SelectHmdSchema = Yup.object().shape({
  hmd: Yup.string().required('Language is required'),
});

export const AddHmdSchema = Yup.object().shape({
  name: Yup.string().required('HMD name is required'),
  deviceId: Yup.string().required('HMD device id is required'),
  color: Yup.string().required('HMD color is required'),
});
